module.exports = __webpack_public_path__ + "img/menu_item.0b0688a8.svg";